import { styled } from 'goober';

import { Checkbox } from '@/ui/checkbox/checkbox';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Modal as ModalComponent } from '@/ui/modal/modal';
import { mediaQuery } from '@/theme/setupTheme';

export const IntroModal = styled(ModalComponent)`
  padding: 44px 60px;
  min-width: 987px;
  min-height: 530px;
`;

export const IntroHeader = styled('h1')`
  ${({ theme }) => theme.typography.enhance.header}
  margin-top: 26px;
  position: relative;

  &:after {
    content: '';
    background-image: url('/src/assets/svg/ai-enhancement-header.svg');
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: calc(-40px - 10px);
    width: 40px;
    height: 58px;
  }
`;

export const IntroText = styled('p')`
  ${({ theme }) => theme.typography.enhance.text}
`;

export const IntroFooter = styled(Flexbox)`
  width: 887px;
`;

export const IntroLogo = styled('img')`
  width: 290px;
  height: 250px;
  position: absolute;
  top: 150px;
  right: 60px;
`;

export const ConfigModal = styled(ModalComponent)`
  padding: 24px 16px;
  width: 95%;
  min-height: 500px;
  max-width: 100%;

  ${mediaQuery('sm', 'min')} {
    padding: 32px 24px;
    width: 90%;
  }

  ${mediaQuery('md', 'min')} {
    padding: 38px 50px;
    width: 85%;
    min-width: 600px;
    max-width: 1250px;
    min-height: 580px;
  }

  ${mediaQuery('lg', 'min')} {
    padding: 38px 50px;
    width: auto;
    min-width: 1250px;
    max-width: 1250px;
    min-height: 48px;
  }
`;

export const FieldLabel = styled('h2')`
  ${({ theme }) => theme.typography.inputs.select.label}
  padding-left: 10px;
`;

export const Footer = styled(Flexbox)`
  width: 100%;
  margin-top: 12px;
`;

export const ProblemDefinitionIntroLogo = styled('img')`
  width: 160px;
  height: 130px;
  object-fit: contain;

  ${mediaQuery('md', 'min')} {
    width: 200px;
    height: 165px;
  }

  ${mediaQuery('lg', 'min')} {
    width: 220px;
    height: 180px;
  }
`;

export const Subheader = styled('div')`
  ${({ theme }) => theme.typography.enhance.subheader}
  padding-left: 12px;

  ${mediaQuery('md', 'min')} {
    padding-left: 18px;
  }

  ${mediaQuery('lg', 'min')} {
    padding-left: 22px;
  }
`;

export const OverflowContainer = styled(Flexbox)`
  overflow-y: auto;
  margin-top: 18px;
  padding-right: 10px;
  ${({ theme }) => theme.mixins.scrollbar}
`;

export const CompanyName = styled('div')`
  ${({ theme }) => theme.typography.enhance.tableCompanyName}
  margin-left: 10px;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
`;

export const KeyOffering = styled(Flexbox)`
  ${({ theme }) => theme.typography.enhance.tableSmallText}
  margin: 5px 16px;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;

  ${mediaQuery('md', 'min')} {
    margin: 5px 30px;
  }

  ${mediaQuery('lg', 'min')} {
    margin: 5px 40px;
  }
`;

export const CompanyNameContainer = styled(Flexbox)`
  max-width: 100%;
  min-width: 0;
`;

export const CompanyNameRow = styled(Flexbox)`
  min-width: 0;
`;

export const RowCheckbox = styled(Checkbox)`
  & + div {
    margin-right: 16px;
  }
`;

export const BackIcon = styled('img')`
  cursor: pointer;
`;

export const HeaderTitle = styled('h1')`
  ${({ theme }) => theme.typography.widget.emptyState}
  display: flex;
`;

export const StepText = styled('p')`
  ${({ theme }) => theme.typography.widget.smallText}
`;
